import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { BreakDistribution } from '../../types';

interface BreakDistributionChartProps {
  distribution: BreakDistribution;
}

const BreakDistributionChart: React.FC<BreakDistributionChartProps> = ({ distribution }) => {
  const data = [
    { range: '0-20', count: distribution.range_0_20 },
    { range: '21-40', count: distribution.range_21_40 },
    { range: '41-60', count: distribution.range_41_60 },
    { range: '61-80', count: distribution.range_61_80 },
    { range: '81-100', count: distribution.range_81_100 },
    { range: '100+', count: distribution.range_100_plus },
  ];

  // Calculate total
  const total = Object.values(distribution).reduce((sum, val) => sum + val, 0);

  // Don't render if no breaks
  if (total === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="range" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#8884d8" name="Breaks" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BreakDistributionChart;

